const handleLogout = async (logoutUrl, csrf) => {
    try {
      // Make a request to your Rails backend's logout endpoint (adjust URL accordingly)
      const response = await fetch(logoutUrl, {
        method: 'DELETE', // Devise uses a DELETE request for logout
        credentials: 'include', // Include cookies for authentication
        headers: {
            'X-CSRF-Token': csrf
        }
      });
  
      if (response.ok) {
        // Redirect to the desired page after successful logout
        window.location.href = '/users/sign_in';
      } else {
        // Handle error if logout request fails
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error during logout: ', error);
    }
};

export default handleLogout;